export default __webpack_public_path__ + "static/media/complete.30c68b98.png";